import m = require("mithril")
import {DragSourceItem} from "../../../model/items/dragdrop/dragSourceItem";
import {DragItemView} from "./dragItemView";
import {Vnode, VnodeDOM} from "mithril";

export class DragSourceView extends DragItemView {
    public static component = {
        view: (vnode: Vnode) => {
            return m(DragSourceView, vnode.attrs);
        }
    };

    constructor(attr: any) {
        super(attr);
        this.cellItem = <DragSourceItem>attr.cellItem;
    }

    view(): Vnode {

        return m("div.dragSourceItem", {
            'class': this.getClass(),
            oncreate: this.setElement.bind(this),
        }, this.getContent());
    }
}